import {memo} from 'react';
import {BusStopData} from '@/map/@types';
import {AROUND_DATA_OPTIONS} from '@/map/constants';
import {AreaAnalyticsFilter} from '@/map/enums';
import {NearbyInfoMarker} from './Marker';

interface IProps extends naver.maps.MarkerOptions {
  item: BusStopData;
}

export const BusStopMarker = memo(
  ({map, position, item}: IProps) => {
    return (
      <NearbyInfoMarker
        typeInfo={AROUND_DATA_OPTIONS[AreaAnalyticsFilter.BUS]}
        config={{
          map,
          position,
        }}
        item={{
          name: item.stopName,
          count: item.avgNumberOfRidesPerDay,
        }}
      />
    );
  },
  (prevProps: IProps, nextProps: IProps) => {
    return prevProps.position.toString() === nextProps.position.toString();
  }
);
